import { Env } from 'types';

export const getCurrentAuthMethod = (env: Env) => {
  return {
    isUsingGateway: env.auth.method === 'gateway',
    isUsingWebseal: env.auth.method === 'webseal',
    isUsingIbmGrant: env.auth.method === 'ibmGrant',
    isUsingAfSso: env.auth.method === 'afSso'
  };
};
